let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("76n7a"), load("l253H"), load("ffQaD"), load("kvRbA"), load("4Z0s8")]).then(() => parcelRequire('iRLc5'));